import { createContext } from "react"

export const ScrolledDownContext = createContext(false)